export const ACCESS_POM_ROLE = 'access-pom';

export const GET_PURCHASE_PLANNING_KEY = ['purchase-planning'];

export const GET_PURCHASE_PLANNING_SUPPLIERS_KEY = [
  'purchase-planning-suppliers',
];

export const CREATE_LOT_SIZING_KEY = ['create-lot-sizing'];

export const UPDATE_LOT_SIZING_CRITERIA_KEY = ['update-lot-sizing-criteria'];

export const GET_LOT_SIZING_CRITERIA_KEY = ['lot-sizing-criteria'];

export const GET_LOT_SIZING_KEY = ['lot-sizing'];

export const GET_LOT_SIZING_LINES_KEY = ['lot-sizing-lines'];

export const CREATE_PURCHASE_ORDER_KEY = ['create-purchase-order'];

export const GET_PURCHASE_ORDERS_KEY = ['purchase-orders'];

export const GET_PURCHASE_ORDER_KEY = ['purchase-order'];

export const GET_PURCHASE_ORDER_ACTIVITY_KEY = ['purchase-order-activity'];

export const SEND_PURCHASE_ORDER_KEY = ['send-purchase-order'];

export const UPDATE_PURCHASE_ORDER_DATES_KEY = ['update-purchase-order-dates'];

export const UPLOAD_PURCHASE_ORDER_DOCUMENT_KEY = [
  'upload-purchase-order-document',
];

export const PURCHASE_ORDER_PDF_PREVIEW_KEY = ['purchase-order-pdf-preview'];

export const GET_SUPPLIERS_KEY = ['suppliers'];

export const GET_SUPPLIER_SUBCONTRACTORS_KEY = ['supplier-subcontractors'];

export const GET_SUPPLY_CHAIN_INFORMATIONS_KEY = ['supply-chain-informations'];

export const GET_CONTAINER_TYPES_KEY = ['container-types'];

export const GET_DOCUMENT_TYPES_KEY = ['document-types'];

export const GET_ACTOR_TYPES_KEY = ['actor-types'];

export const GET_COUNTRIES_KEY = ['countries'];

export const GET_FOREST_TYPES_KEY = ['forest-types'];

export const GET_LOT_SIZINGS_KEY = ['lot-sizings'];

export const GET_PURCHASE_ORDER_TOTALS_KEY = ['purchase-order-totals'];

export const GET_PURCHASE_ORDER_LINES_KEY = ['purchase-order-lines'];

export const GET_PURCHASE_ORDER_SYNCABLE_FIELDS_KEY = [
  'purchase-order-syncable-fields',
];

export const SYNC_PURCHASE_ORDER_LINES_KEY = ['sync-purchase-order-lines'];

export const GET_PURCHASE_ORDER_DOCUMENTS_KEY = ['purchase-order-documents'];

export const GET_PRODUCTION_DECLARATION_KEY = ['production-declaration'];

export const GET_PRODUCTION_DECLARATION_MATERIALS_KEY = [
  'production-declaration-materials',
];

export const GET_PRODUCTION_DECLARATION_MATERIAL_PRODUCTS_KEY = [
  'production-declaration-material-products',
];

export const GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY = [
  'production-declaration-material-commodity-origins',
];

export const DELETE_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_KEY = [
  'delete-production-declaration-material-commodity-origin',
];

export const GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY =
  ['production-declaration-commodity-origin-production-places'];
export const GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY =
  ['production-declaration-material-commodity-origin-documents'];
export const DELETE_PRODUCTION_DECLARATION_DOCUMENT_KEY = [
  'delete-production-declaration-document',
];
export const UPLOAD_PRODUCTION_DECLARATION_DOCUMENTS_KEY = [
  'upload-production-declaration-documents',
];
export const GET_PRODUCTION_DECLARATION_MATERIALS_COMPLETENESS_KEY = [
  'production-declaration-materials-completeness',
];
export const UPDATE_PRODUCTION_DECLARATION_KEY = [
  'update-production-declaration',
];
export const CREATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY = [
  'create-production-declaration-correction-request',
];
export const UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_RESOLUTION_KEY = [
  'update-production-declaration-correction-request-resolution',
];
export const UPDATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_COMMENT_KEY = [
  'update-production-declaration-correction-request-comment',
];
export const DELETE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY = [
  'delete-production-declaration-correction-request',
];
export const GET_PRODUCTION_DECLARATION_CORRECTION_REQUESTS_KEY = [
  'production-declaration-correction-requests',
];
export const UPDATE_PRODUCTION_DECLARATION_MATERIAL_STATUS_KEY = [
  'update-production-declaration-material-status',
];

export const GET_COUNTRY_RISKS_KEY = ['country-risks'];
